module.exports = __webpack_public_path__ + "static/media/isletnet_app_ntb.aea7d1a1.png";